module.exports = __webpack_public_path__ + "images/emoji/pig.a4fff4cc8a979344185e.png";